import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopAdhesionGak from './gak/DesktopAdhesion';
import DesktopAdhesionNitro from './nitro/DesktopAdhesion';
const DesktopAdhesion = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopAdhesionGak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopAdhesionNitro, {
        safety: safety
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
